import { getStandardBranchManager } from '../core/factory';
import { EN_STANDARD_BRANCH_NAMESPACE } from '../core/types/interface';
import { IPluginCommon } from './interface_plugin';

export const registerPlugin = (
  clazz: IPluginCommon,
  forceOptions?: {
    namespace?: EN_STANDARD_BRANCH_NAMESPACE;
    symbol?: any;
    description?: string;
    allowMulti?: boolean;
  }
): void => {
  let { namespace, symbol, description, allowMulti } = clazz;

  if (forceOptions) {
    namespace = forceOptions.namespace ?? namespace;
    symbol = forceOptions.symbol ?? symbol;
    description = forceOptions.description ?? description;
    allowMulti = forceOptions.allowMulti ?? allowMulti;
  }

  getStandardBranchManager().register(namespace, symbol, description, allowMulti)(clazz);
};
